import React, { useEffect } from "react";
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import BColor from '../BColor'
import { hashCode } from "../util/Syno";

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 3, 2),
  },
  heroContent1: {
    padding: theme.spacing(8, 3, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  cardmenu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },
}));


function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}


export default function Donation1() {
  const classes = useStyles();

  const [hasLic, setHasLic] = React.useState(0);
  const [lic, setLic] = React.useState(null);
  const [lictxt, setLictxt] = React.useState("");
  const [inlic, setInLic] = React.useState("");

  const [noad, setNoad] = React.useState(false)
  const [p1, setP1] = React.useState(false);
  const [p2, setP2] = React.useState(false);


  useEffect(() => {
    checkLic();
  }, []);


  const checkLic = () => {
    let lic = localStorage.getItem('lic')

    if (lic != null) {
      let param = {
        lic: lic
      }

      fetch("/jstock/v1/stock/checklic", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(param)
      })
        .then(res => res.json())
        .then(
          result => {
            if (result.status === 0) {
              if (result.hlic != null) {
                setNoad(result.hlic.noad)
                setHasLic(result.hlic.licok)
                setLic(result.hlic)

                if (result.hlic.licok === 1 || result.hlic.tp === 3) {
                  localStorage.setItem('noad', 1);
                } else localStorage.setItem('noad', 0);

              } else {
                setHasLic(0)
                localStorage.setItem('noad', 0);
                setNoad(false)
                setP1(false)
                setP2(false)
              }

              if (result.lp != null) {
                setP1(result.lp.p1)
                setP2(result.lp.p2)
              }
            } else {
              setHasLic(0)
              localStorage.setItem('noad', 0);
              setNoad(false)
              setP1(false)
              setP2(false)
            }
          },
          error => {
            // setHasLic(0)
            // localStorage.setItem('noad', 0);
            // setNoad(false)
            // setP1(false)
            // setP2(false)
          }
        );
    }
  }


  const clearLic = () => {
    localStorage.removeItem('lic')
    localStorage.setItem('noad', 0);
    setHasLic(0)
    setNoad(false)
    setLictxt("")
    setLic(null)

  }

  const checkLicByLic = () => {
    let lic = inlic

    if (lic != null) {
      let param = {
        lic: lic
      }

      fetch("/jstock/v1/stock/checklic", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(param)
      })
        .then(res => res.json())
        .then(
          result => {
            if (result.status === 0) {

              if (result.hlic != null) {
                localStorage.setItem('lic', lic);
                setNoad(result.hlic.noad)
                setHasLic(result.hlic.licok)
                setLic(result.hlic)
                setLictxt("")
                
                localStorage.removeItem("lica")


                if (result.hlic.licok === 1 || result.hlic.tp === 3)
                  localStorage.setItem('noad', 1);
                else localStorage.setItem('noad', 0);

              } else {
                setHasLic(0)
                localStorage.setItem('noad', 0);
                setLictxt("此序號不存在")
              }

              if (result.lp != null) {
                setP1(result.lp.p1)
                setP2(result.lp.p2)
              }
            } else {
              setHasLic(0)
              localStorage.setItem('noad', 0);
              setLictxt("此序號不存在")
            }
          },
          error => {
            // setHasLic(0)
            // localStorage.setItem('noad', 0);
            // setLictxt("此序號不存在")
          }
        );
    }
  }

  const getNewLicId = () => {
    let id = makeid(6)
    localStorage.setItem("lica", id)
    return id
  }

  const fectchAPIK = (tp) => {
    if (lic != null && lic.lic != null && lic.lic.length > 0) {
      let newLic = tp.toString() + '' + lic.lic.substr(lic.tp.toString().length)
      localStorage.setItem('lic', newLic);
      console.log("lic" + newLic)

      let url = "/jstock/v1/stock/donate?tp=" + tp + "&lic=" + newLic + "#price"
      var win = window.open(url, "_blank", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=800");
    } else {
      let lica = localStorage.getItem('lica') != null ? localStorage.getItem('lica') : getNewLicId()
      let lic = tp.toString() + '' + lica
      localStorage.setItem('lic', lic);
      console.log("lic" + lic)

      let url = "/jstock/v1/stock/donate?tp=" + tp + "&lic=" + lic + "#price"
      var win = window.open(url, "_blank", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=800");
    }
  }


  // const fectchAPIK1 = (tp) => {
  //   let lica = localStorage.getItem('lica') != null ? localStorage.getItem('lica') : getNewLicId()
  //   let lic = tp.toString() + '' + lica
  //   localStorage.setItem('lic', lic);
  //   console.log("lic" + lic)

  //   let url = "/jstock/v1/stock/donate1?tp=" + tp + "&lic=" + lic + "#price"
  //   var win = window.open(url, "_blank", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1024,height=800");
  // }

  const inputLic = name => event => {
    setInLic(event.target.value)
  }

  const renderButton = (tier) => {
    if (tier.tp === '') {
      return <Button fullWidth variant={tier.buttonVariant} style={{ backgroundColor: "#8a8a8a", color: "#FFFFFF" }} disabled size='large'>
        {tier.buttonText}
      </Button>
    } else if (tier.tp === '10' && p1 === false) {
      return <Button fullWidth variant={tier.buttonVariant} color="primary" disabled size='large'>
        {tier.buttonText}
      </Button>
    } else if (tier.tp === '11' && p2 === false) {
      return <Button fullWidth variant={tier.buttonVariant} color="primary" disabled size='large'>
        {tier.buttonText}
      </Button>
      // } else if (tier.tp === '15' || tier.tp === '7' || tier.tp === '16') {
      //   return <Button fullWidth variant={tier.buttonVariant} style={{backgroundColor:"#8a8a8a", color:"#FFFFFF"}}  size='large' onClick={event => fectchAPIK1(tier.tp)}>
      //     {tier.buttonText}
      //   </Button>
    } else {
      return <Button fullWidth variant={tier.buttonVariant} style={{ backgroundColor: "#1c1c1c", color: "#FFFFFF" }} size='large' onClick={event => fectchAPIK(tier.tp)}>
        {tier.buttonText}
      </Button>
    }
  }


  // const renderButton1 = (tier) => {
  //   if (tier.buttonText1 != null && tier.buttonText1 != '') {
  //     if (tier.tp === '8') {
  //       return <Button  onClick={e => handleOk1(0)} fullWidth variant={tier.buttonVariant} style={{backgroundColor:"#1c1c1c", color:"#FFFFFF"}}  size='large'>
  //       {tier.buttonText1}
  //     </Button>
  //     } else if (tier.tp === '14') {
  //       return <Button  onClick={e => handleOk1(1)} fullWidth variant={tier.buttonVariant} style={{backgroundColor:"#1c1c1c", color:"#FFFFFF"}}  size='large'>
  //       {tier.buttonText1}
  //     </Button>        
  //     } else if (tier.tp === '9') {
  //       return <Button  onClick={e => handleOk1(2)} fullWidth variant={tier.buttonVariant} style={{backgroundColor:"#1c1c1c", color:"#FFFFFF"}}  size='large'>
  //       {tier.buttonText1}
  //     </Button>        
  //     } return null
  //   } else {
  //     return null
  //   }
  // }


  const getTitle = () => {
    if (lic === null) return '免費'
    else if (lic.tp === 2) return '無使用期限'
    else if (lic.tp === 3) return '無廣告'
    else if (lic.tp === 4) return '試用十天'
    else if (lic.tp === 5) return '訂閱一個月'
    else if (lic.tp === 0) return '每月繳'
    else if (lic.tp === 12) return '每季繳'
    else if (lic.tp === 13) return '每季繳優惠#1'
    else if (lic.tp === 6) return '每半年繳'
    else if (lic.tp === 7) return '每年繳'
    else if (lic.tp === 8) return '訂閱半年'
    else if (lic.tp === 9) return '無使用期限'
    else if (lic.tp === 10) return '無使用期限優惠#1'
    else if (lic.tp === 11) return '無使用期限優惠#2'
    else if (lic.tp === 14) return '訂閱一年'
    else if (lic.tp === 15) return '每月繳'
    else if (lic.tp === 16) return '買斷三年'
    else if (lic.tp === 17) return '買斷六年'
    else if (lic.tp === 98) return '每月繳'
    else if (lic.tp === 99) return '每年繳'    
    else return ''
  }

  const getExpireTitle = () => {
    if (lic.expire != null)
      return lic.expire
    else if (lic.tp != null && (lic.tp === 0 || lic.tp === 7 || lic.tp === 15 || lic.tp === 98 || lic.tp === 99))
      return "訂閱期間有效"
    else
      return '無特定期限'
  }

  const getPriceList = () => {
    let tiers = [
      {
        title: '免費',
        price: '0',
        description: [
          '會有廣告在手機版的最下方',
          '搜尋結果最多10筆',
          '手機跟電腦分開使用不能同步',
          '換手機無法保留自選股與選股策略',
          '沒有產業,懶人,轉折波,型態選股',
          '沒有交易日誌,回測系統,相似型態',
        ],
        buttonText: '直接使用',
        buttonVariant: 'outlined',
        unit: '',
        tp: '',
      },
    ];

    let lic = localStorage.getItem('lic')
    // if (lic != null && (hashCode(lic) === 1404558798 || hashCode(lic) === -1100120674)) {
    //   tiers.push(
    //     {
    //       title: '舊方案-月訂閱',
    //       price: "188",
    //       description: [
    //         <div style={{ backgroundColor: BColor.upcolor, color: "#FFFFFF" }}></div>,
    //         '信用卡每月自動扣款',
    //         '訂閱期間解鎖所有功能',
    //         <div style={{ color: BColor.upcolor }}>取消訂閱: 大名與手機末五碼寄信到jookershop@gmail.com隨即會有專人處理</div>
    //       ],
    //       buttonText: '刷卡訂閱',
    //       buttonVariant: 'outlined',
    //       unit: '/每月',
    //       tp: '0',
    //     }
    //   )
    // } 

    // tiers.push(
    //   {
    //     title: '十天方案',
    //     price: '99',
    //     description: [
    //       '十天內解鎖所有功能與限制',
    //       '十天內無任何廣告',
    //       '十天內新功能免費使用'
    //     ],
    //     buttonText: '刷卡,ATM,超商',
    //     buttonVariant: 'outlined',
    //     unit: '/10天',
    //     tp: '4',
    //   }
    // )

    tiers.push(
      {
        title: '月訂閱',
        price: '268',
        description: [
          '信用卡每月自動扣款',
          '訂閱期間解鎖所有功能',
          <div style={{ color: BColor.upcolor }}>取消訂閱: 大名與手機末五碼寄信到jookershop@gmail.com隨即會有專人處理</div>
        ],
        buttonText: '刷卡訂閱',
        buttonVariant: 'outlined',
        unit: '/每月',
        tp: '98',
      }
    )


    tiers.push(
      {
        title: '年訂閱',
        price: '2688',
        description: [
          '信用卡每年自動扣款',
          '訂閱期間解鎖所有功能',
          <div style={{ color: BColor.upcolor }}>取消訂閱: 大名與手機末五碼寄信到jookershop@gmail.com隨即會有專人處理</div>
        ],
        buttonText: '刷卡訂閱',
        buttonVariant: 'outlined',
        unit: '/每年',
        tp: '99',
      },
      {
        title: '三年優惠方案',
        price: '3888',
        description: [
          '三年內解鎖所有功能與限制',
          '三年內無任何廣告',
          '三年內新功能免費使用',
        ],
        buttonText: '刷卡,ATM,超商',
        buttonVariant: 'outlined',
        unit: '/3年',
        tp: '16',
      },
      {
        title: '六年優惠方案',
        price: '5888',
        description: [
          '六年內解鎖所有功能與限制',
          '六年內無任何廣告',
          '六年內新功能免費使用',
        ],
        buttonText: '刷卡,ATM,超商',
        buttonVariant: 'outlined',
        unit: '/6年',
        tp: '17',
      },
    )
    return tiers;
  }


  return (
    <React.Fragment>
      <CssBaseline />

      <Container maxWidth="md" component="main" className={classes.heroContent}>
        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
          方案價格
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          
        </Typography>
      </Container>

      {(lic != null && (lic.licok === 1 || lic.tp === 3)) &&
        <Container maxWidth="md" component="main" style={{ marginBottom: 30 }}>
          <Grid container spacing={5} alignItems="flex-end">
            <Grid item key={"aa"} xs={12} sm={12} md={12}>
              <Card>
                <CardHeader
                  title={getTitle()}
                  subheader={""}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center' }}
                  action={<StarIcon />}
                  className={classes.cardHeader}
                />
                <CardContent>
                  <div className={classes.cardmenu}>
                    <Typography variant="h6" color="textPrimary">
                      序號
                    </Typography>
                  </div>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h3" color="textPrimary">
                      {lic.lic}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">

                    </Typography>
                  </div>

                  <ul>
                    <Typography component="li" variant="subtitle1" align="center" key={Math.random()}>
                      使用期限：{getExpireTitle()}
                    </Typography>
                    <Typography component="li" variant="caption" align="center" color="textSecondary">
                      妥善保管，勿公開給他人使用
                    </Typography>
                  </ul>
                </CardContent>
                <CardActions>
                  <Button style={{ width: '100%', backgroundColor: "#1c1c1c", color: "#FFFFFF" }} size="large" fullWidth variant="outlined" align="center" color="primary" onClick={event => clearLic()}>清除
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Container>}


      {!(lic != null && (lic.licok === 1 || lic.tp === 3)) && <Container maxWidth="md" component="main" style={{ marginBottom: 30 }}>
        <Grid container spacing={5} alignItems="flex-end">
          <Grid item key={"aa"} xs={12} sm={12} md={12}>
            <Card>
              <CardHeader
                title={'我已有序號'}
                subheader={""}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={<StarIcon />}
                className={classes.cardHeader}
              />
              <CardContent>
                <TextField
                  id="standard-name"
                  label="輸入序號"
                  onChange={inputLic('')}
                  fullWidth
                  style={{ fontSize: 18 }}
                  helperText={lictxt}
                />
                <br />
                <Typography variant="caption" color="textSecondary" component="p">
                  <li>使用信用卡後約30秒後請重新開啟程式或重新整理網頁，系統會自動填入序號並解鎖，不另寄通知。</li>
                  <li>使用超商繳費因入帳時間不確定，所以解鎖時間約需1-3天</li>
                  <li>使用超商繳費想加快解鎖者，請將超商收據寄到<a href="mailto:jookershop@gmail.com">jookershop@gmail.com</a>確認後會立即寄發序號讓您手動解鎖</li>
                  <li>無法解鎖或遺失碼者請提供訂單完成信件或超商收據寄到<a href="mailto:jookershop@gmail.com">jookershop@gmail.com</a>以利補發</li>
                  <li>序號請自行妥善保管，勿公開給他人使用，以免之後限制裝置數量時產生使用上的困擾</li>
                </Typography>
              </CardContent>
              <CardActions>
                <Button style={{ width: '100%', backgroundColor: "#1c1c1c", color: "#FFFFFF" }} size="large" fullWidth variant="outlined" align="center" color="primary" onClick={event => checkLicByLic()}>送出
                </Button>
              </CardActions>
            </Card>
          </Grid>

          {/* <Grid item key={"db"} xs={12} sm={6} md={6}>
            <Card>
              <CardHeader
                title={'輸入綁定資訊'}
                subheader={""}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={<StarIcon />}
                className={classes.cardHeader}
              />
              <CardContent>
                <Stack direction={"column"} spacing={1}>
                  <TextField
                    id="name"
                    label="姓名"
                    onChange={e => setName(e.target.value)}
                    fullWidth
                    style={{ fontSize: 18 }}
                  />
                  <TextField
                    id="phone"
                    label="手機後五碼"
                    onChange={e => setPhone(e.target.value)}
                    fullWidth
                    style={{ fontSize: 18 }}
                    helperText={mapTxt}
                  />
                  <Typography variant="caption" color="textSecondary" component="p">
                    <li>若之前已經將序號綁定在個人資訊上，可直接輸入姓名與手機後五碼，即可自動帶進序號</li>
                  </Typography>
                </Stack>
              </CardContent>
              <CardActions>
                <Button style={{ width: '100%', backgroundColor: "#1c1c1c", color: "#FFFFFF" }} size="large" fullWidth variant="outlined" align="center" color="primary" onClick={event => checkLicByLic()}>送出
                </Button>
              </CardActions>
            </Card>
          </Grid> */}


        </Grid>
      </Container>}


      {/* End hero unit */}
      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {getPriceList().map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item key={tier.title + '' + tier.price} xs={12} sm={tier.title === '訂閱' ? 6 : 6} md={tier.title === '訂閱' ? 4 : 4}>
              <Card >
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center' }}
                  action={tier.title === '無使用期限-即將結束' ? <StarIcon /> : null}
                  className={classes.cardHeader}
                />
                <CardContent style={{ minHeight: 310 }}>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h3" color="textPrimary">
                      ${tier.price}元
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                      {tier.unit}
                    </Typography>
                  </div>
                  <div className={classes.cardmenu}>
                    <Typography variant="h6" color="textPrimary">

                    </Typography>
                  </div>
                  <ul>

                    {tier.description.map((line) => (
                      <Typography component="li" variant="subtitle1" align="center" key={line + Math.random()}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  {renderButton(tier)}
                  {/* {renderButton1(tier)} */}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* <Container maxWidth="md" component="main" className={classes.heroContent}>
        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
          樂捐
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          真心喜歡此軟體想要給予實質上的相挺，歡迎透過無限定金額的自由樂捐來支持我們。
        </Typography>

          <Grid container spacing={0} alignItems="flex-end">
            <Grid item key={"aa"} xs={12} sm={12} md={12}>
              <Card>
                <CardHeader
                  title={'自由樂捐'}
                  subheader={""}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center' }}
                  action={<StarIcon />}
                  className={classes.cardHeader}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h3" color="textPrimary">
                      {'不限金額'}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">

                    </Typography>
                  </div>

                  <ul>
                    <Typography component="li" variant="subtitle1" align="center" key='1a'>
                      <div style={{ color: "#b52222" }}>樂捐並無序號，無序號，無序號解鎖</div>
                    </Typography>
                    <Typography component="li" variant="subtitle1" align="center" key='1b'>
                      免費用戶也能力挺
                    </Typography>
                    <Typography component="li" variant="subtitle1" align="center" key='1c'>
                      已訂閱者想加碼支持
                    </Typography>
                    <Typography component="li" variant="subtitle1" align="center" key='1d'>
                      股市獲利者想分紅給股票挖土機
                    </Typography>
                  </ul>
                </CardContent>
                <CardActions>
                  <Button variant="contained" style={{ width: '100%', marginTop: 10, backgroundColor: "#1c1c1c", color: "#FFFFFF" }} size="large" onClick={handleClickOpen}>去樂捐</Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
          <Dialog
            open={open}
            onClose={handleClose}
          >
            <DialogTitle id="alert-dialog-title">貼心提醒</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <font style={{color:"#a8324c"}}>樂捐無序號</font>，所以沒有解鎖任何進階的功能。如果需要有序號請選擇其他方案。
          </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                取消
              </Button>
              <Button onClick={handleOk} color="primary" autoFocus>
                還是要樂捐
          </Button>
            </DialogActions>
          </Dialog>
      </Container> */}
    </React.Fragment>
  );
}